import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

export default class InstitutionsList extends Component {

  componentDidMount = () => {
    this.props.institutionActions.loadList();
  }

  handleRedirect = () => {
    window.location.href = '/institutions/create';
  }

  css_class = {
    paddingLeft: 2,
    paddingRight: 2,
    whiteSpace: 'normal',
    wordWrap: 'break-wor',
    fontSize: '17px',
  };

  button_label_css_class = {
    fontSize: '17px',
  }

  // タイトルは色だけ違う.
  css_class_title = Object.assign({}, this.css_class, { color: '#000080' });

  render() {
    const institutionsList = this.props.institution.listData;
    let institutions = null;
    if (institutionsList) {
      institutions = Object.keys(institutionsList).map((key) => {
        // institution_idではないことに注意.
        let id = institutionsList[key].institution_sub;
        // こっちは詳細.
        // let institutionUrl = "/institutions/detail?id=" + id;
        let institutionUrl = "/institutions/update?id=" + id;

        return (
          <TableRow key={key}>
            <TableRowColumn style={this.css_class}>{institutionsList[key].institution_name}</TableRowColumn>
            <TableRowColumn style={this.css_class}>{institutionsList[key].company_name}</TableRowColumn>
            <TableRowColumn style={this.css_class}>
              <a href={institutionUrl}>
                {institutionsList[key].institution_id}
              </a>
            </TableRowColumn>
            <TableRowColumn style={this.css_class}>{institutionsList[key].application_year_month}</TableRowColumn>
            <TableRowColumn style={this.css_class}>{institutionsList[key].institution_email}</TableRowColumn>
            <TableRowColumn style={this.css_class}>{institutionsList[key].institution_phone}</TableRowColumn>
            <TableRowColumn style={this.css_class}>{institutionsList[key].created_at}</TableRowColumn>

            <TableRowColumn style={this.css_class}>{institutionsList[key].updated_at}</TableRowColumn>
          </TableRow>
        );
      });
    } else {
      institutions = (
        <CircularProgress size={200} thickness={15} />
      );
    }

    return (
      <div>
        <RaisedButton type="button" label="新規登録" primary={true} style={{margin: 18}} labelStyle={this.button_label_css_class} onClick={
          () => { this.handleRedirect();}}/>
        <Table selectable={false} style={{position: 'relative', margin: 'auto', textAlign: 'center'}}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false} style={{
              margin: 'auto', textAlign: 'center'
            }}>
            <TableRow>
              <TableHeaderColumn style={this.css_class_title}>施設名</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>法人名</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>事業所番号(ログインID)</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>入会月</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>メールアドレス</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>電話番号</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>登録日</TableHeaderColumn>
              <TableHeaderColumn style={this.css_class_title}>更新日</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} style={{
              margin: 'auto', textAlign: 'center'
            }}>
            { institutions ?
            institutions
             : (
              <CircularProgress size={200} thickness={15} />
            )}
          </TableBody>
        </Table>
      </div>
    );
  }
}

InstitutionsList.propTypes = {
  institution: PropTypes.object.isRequired,
  institutionActions: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/InstitutionsList.js